export default "__VITE_ASSET__53ab708f__"